import React from 'react';
import { Award, BookOpen, CheckCircle, Clock } from "lucide-react";
import PurchaseButton from "./PurchaseButton";

export default function Packages() {
  return (
    <div className="grid md:grid-cols-3 gap-8">
      {/* Beginner Package */}
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-indigo-100 transition-transform hover:transform hover:scale-105">
        <div className="p-8">
          <div className="h-14 w-14 bg-indigo-100 rounded-full flex items-center justify-center mb-6">
            <BookOpen className="h-6 w-6 text-indigo-600" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Beginner</h3>
          <p className="text-gray-600 mb-6">Perfect for those just starting their LSAT journey.</p>
          <div className="text-3xl font-bold text-gray-900 mb-6">$4.95<sub className="ml-1 text-xs">/ 5 beginner tests</sub></div>
          <div className="space-y-3 mb-8">
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">Extended time on practice tests</p>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">Two LSAT Gain &trade; booster packs per test</p>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">Basic analytics</p>
            </div>
          </div>
          <PurchaseButton title="Get Started" product="prod_RkCDpp9lK094Vp" />
        </div>
      </div>
      
      {/* Intermediate Package */}
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-indigo-500 transform scale-105 z-10">
        <div className="bg-indigo-500 py-2">
          <p className="text-white text-center font-medium">Most Popular</p>
        </div>
        <div className="p-8">
          <div className="h-14 w-14 bg-indigo-100 rounded-full flex items-center justify-center mb-6">
            <Clock className="h-6 w-6 text-indigo-600" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Intermediate</h3>
          <p className="text-gray-600 mb-6">Designed for students ready to advance their skills.</p>
          <div className="text-3xl font-bold text-gray-900 mb-6">$5.95<sub className="ml-1 text-xs">/ 5 intermediate tests</sub></div>
          <div className="space-y-3 mb-8">
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">Standard-timed practice tests</p>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">One LSAT Gain &trade; booster pack</p>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">Advanced analytics</p>
            </div>
          </div>
          <PurchaseButton theme="pop" title="Get Started" product="prod_RkCELICYy13v86" />
        </div>
      </div>
      
      {/* Expert Package */}
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-indigo-100 transition-transform hover:transform hover:scale-105">
        <div className="p-8">
          <div className="h-14 w-14 bg-indigo-100 rounded-full flex items-center justify-center mb-6">
            <Award className="h-6 w-6 text-indigo-600" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Expert</h3>
          <p className="text-gray-600 mb-6">For serious students aiming for top-tier law schools.</p>
          <div className="text-3xl font-bold text-gray-900 mb-6">$6.95<sub className="ml-1 text-xs">/ 5 advance tests</sub></div>
          <div className="space-y-3 mb-8">
          <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">Complete analytics</p>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">Advanced questionaire for maximizing your final LSAT score</p>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
              <p className="text-gray-700">AI-Generated study recommendations</p>
            </div>
          </div>
          <PurchaseButton title="Get Started" product="prod_RkCECRaRJ6oZJ4" />
        </div>
      </div>
    </div>
  );
}
